import React from 'react';
import { InsightsAbbr, INSIGHTS_ABBREVIATIONS } from './insightsAbbreviations';

interface Props {
    /** Defaults to the shared Insights abbreviation list. */
    items?: InsightsAbbr[];
}

/**
 * Top-of-page legend for dense table / strip abbreviations.
 * Collapsed by default so it does not steal the first viewport.
 */
const InsightsLegend: React.FC<Props> = ({ items = INSIGHTS_ABBREVIATIONS }) => {
    if (items.length === 0) return null;

    return (
        <details className="insightsLegend">
            <summary className="insightsLegendSummary">Abbreviations</summary>
            <dl className="insightsLegendList">
                {items.map((item) => (
                    <div key={item.short} className="insightsLegendItem">
                        <dt>{item.short}</dt>
                        <dd>{item.full}</dd>
                    </div>
                ))}
            </dl>
        </details>
    );
};

export default InsightsLegend;
